<template>
    <div class="strategic__contain">
        <NavSecond :banner="icon_stra"></NavSecond>
        <div class="wrapper__w">
            <div class="superstars_type animate__animated  animate__fadeInUp"><span>合作设计师</span></div>
            <div class="superstars_group">
                <div class="sg_grid item-slider wow animate__fadeInUp"  @click="preeItem('/strategic/designer', {id: item.id})" data-wow-delay=".2s" data-wow-duration="0.8s" v-for="(item, index) in designerList" :key="index">
                    <div class="picture_tost"></div>
                    <div class="picture_effect_des"><span>{{item.name}}</span></div>
                    <div class="picture_effect_box waypoint_ani animated" style="transition-delay: 0s;">
                        <div class="picture p_i_e_box" :style="{'background-image':'url('+item.image+')'}"></div>
                        <div class="hover_img p_i_e_box" :style="{'background-image':'url('+item.project_image+')'}"></div>
                    </div>
                </div>
            </div>
            <div class="look__more" @click="lookMore()"><span>查看更多</span></div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Footer from '@/layouts/Footer'
    import icon_stra from '@/assets/img/strabanner.png'
    import NavSecond from '@/components/NavSecond'
    export default {
        name: 'Test',
        data (){
            return {
                icon_stra,
                designerList: [],
                pagenum: 1,
                pagesize: 9,
            }
        },
        components: {
            NavSecond,
            Footer
        },
        methods: {
            /**
             * @description点击跳转
             * */
            preeItem (path, query){
                this.$router.push({path, query})
            },
            /**
             * @description获取合作项目设计师列表
             * */
            getDesiger (){
                this.$xhr(this.$api.designerList, {pagesize: this.pagesize, pagenum: this.pagenum}).then(res => {
                    this.designerList = res.list
                })
            },
            lookMore (){
                this.pagesize+=9
                this.getDesiger()
            }
        },
        mounted() {
            this.$wow.init()
            this.$nextTick(() => {
                this.getDesiger()
            })
        },
    }
</script>
<style  lang="scss" scoped>
    .strategic__contain
    {
        .look__more{
            text-align: center;
            margin: 80px 0;
            cursor: pointer;
            span{
                display: inline-block;
                margin: 0 auto;
                height: 58px;
                line-height: 58px;
                border: 1px solid #808080;
                font-size: 22px;
                font-weight: 400;
                color: #808080;
                padding: 0 75px;
            }
        }
        .picture_tost{
            position: absolute;
            left: 0;
            top: 0;
            background: rgba(0,0,0,.2);
            width: 100%;
            height: 100%;
            z-index: 2;
        }
        .superstars_type, .picture_effect_des{
            text-align: center;
            font-size: 36px;
            font-weight: bold;
            color: #010101;
            height: 200px;
            line-height: 250px;
            span{
                position: relative;
                &::after{
                    content: '';
                    display: block;
                    position: absolute;
                    left: 50%;
                    margin-left: -16px;
                    bottom: -20px;
                    width: 32px;
                    height: 4px;
                    background: #F55E1B;
                }
            }

        }
        .picture_effect_des{
            position: absolute;
            width: 100%;
            z-index: 3;
            text-align: center;
            bottom: 80px;
            left: 0;
            height: auto;
            font-size: 28px;
            font-weight: bold;
            color: #FEFEFE;
            line-height: 26px;
            z-index: 2223333;
            background: transparent;
            span::after{
                bottom: -15px;
            }
        }
        .superstars_group{
            font-size:0;
            margin-top:4.56%;
            display:flex;
            justify-content:flex-start;
            align-items:center;
            flex-wrap:wrap;
        }
        .superstars_group .sg_grid{
            width:33.33%;
            height:560px;
            cursor:pointer;
            position: relative;
        }
        .superstars_group .sg_grid .picture_effect_box{position:relative;width:100%;height:100%;overflow:hidden;}
        .superstars_group .sg_grid:hover .picture{opacity:0;
            -webkit-transform: matrix(1.05,0,0,1.05,0,0);
            -moz-transform: matrix(1.05,0,0,1.05,0,0);
            -ms-transform: matrix(1.05,0,0,1.05,0,0);
            -o-transform: matrix(1.05,0,0,1.05,0,0);
            transform: matrix(1.05,0,0,1.05,0,0);
        }
        .superstars_group .sg_grid:hover .hover_img{
            opacity:1;
            -webkit-transform: matrix(1,0,0,1,0,0);
            -moz-transform: matrix(1,0,0,1,0,0);
            -ms-transform: matrix(1,0,0,1,0,0);
            -o-transform: matrix(1,0,0,1,0,0);
            transform: matrix(1,0,0,1,0,0);
        }
        .picture_effect_box .p_i_e_box{width:100%;height:100%;position:absolute;top:0;left:0;font-size:0;background-repeat:no-repeat;background-position:center;background-size:cover;
            transition: all 0.3s ease-in-out;
        }
        .picture_effect_box .p_i_e_box img{width:100%;height:100%;}
        .picture_effect_box .p_i_e_box.picture{opacity:1;
            -webkit-transform: matrix(1,0,0,1,0,0);
            -moz-transform: matrix(1,0,0,1,0,0);
            -ms-transform: matrix(1,0,0,1,0,0);
            -o-transform: matrix(1,0,0,1,0,0);
            transform: matrix(1,0,0,1,0,0);
        }
        .picture_effect_box .p_i_e_box.hover_img{
            opacity: 0;
            -webkit-transform: matrix(1.1,0,0,1.1,0,0);
            -moz-transform: matrix(1.1,0,0,1.1,0,0);
            -ms-transform: matrix(1.1,0,0,1.1,0,0);
            -o-transform: matrix(1.1,0,0,1.1,0,0);
            transform: matrix(1.1,0,0,1.1,0,0);
        }

    }
</style>
